import React from 'react';
import { DesertLanding } from './components/DesertLanding';
export function App() {
  return <DesertLanding data-id="element-0" />;
}